import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Activity from "./pages/Activity";
import FinalizeActivity from "./pages/FinalizeActivity";
import Profile from "./pages/Profile";
import MagicPage from "./pages/MagicPage";
import ThemeCustomizer from "./pages/ThemeCustomizer";
import Casino from "./pages/Casino";
import Slots from "./pages/Slots";
import Blackjack from "./pages/Blackjack";
import Pokedex from "./pages/Pokedex";
import MapView from "./pages/MapView";
import FoodPicker from "./pages/FoodPicker";

function ProtectedRoute({ authState, children }) {
  if (authState !== "valid") {
    return <Navigate to="/oops" replace />;
  }
  return children;
}

export default function App({ authState }) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/magic/:token" element={<MagicPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute authState={authState}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activity"
          element={
            <ProtectedRoute authState={authState}>
              <Activity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activity/finalizar"
          element={
            <ProtectedRoute authState={authState}>
              <FinalizeActivity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute authState={authState}>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/theme"
          element={
            <ProtectedRoute authState={authState}>
              <ThemeCustomizer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/casino"
          element={
            <ProtectedRoute authState={authState}>
              <Casino />
            </ProtectedRoute>
          }
        />
        <Route
          path="/casino/slots"
          element={
            <ProtectedRoute authState={authState}>
              <Slots />
            </ProtectedRoute>
          }
        />
        <Route
          path="/casino/blackjack"
          element={
            <ProtectedRoute authState={authState}>
              <Blackjack />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pokedex"
          element={
            <ProtectedRoute authState={authState}>
              <Pokedex />
            </ProtectedRoute>
          }
        />
        <Route
          path="/map"
          element={
            <ProtectedRoute authState={authState}>
              <MapView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/comer"
          element={
            <ProtectedRoute authState={authState}>
              <FoodPicker />
            </ProtectedRoute>
          }
        />
        <Route
          path="/oops"
          element={
            <div className="min-h-screen flex items-center justify-center bg-slate-100 text-slate-800">
              Algo ha ido mal. Intenta volver a iniciar sesión.
            </div>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
